import request from "./axios.instance";

/**
 * The API answers HTTP 200 even for handled failures, signalling them only via the
 * `{ status: 'FAILURE' }` envelope. Route those to errorCallback so success handlers
 * never receive an error payload where they expect real data.
 */
const dispatchResponse = (response, successCallback, errorCallback) => {
  if (response?.data?.status === "FAILURE") {
    if (typeof errorCallback === "function") errorCallback(response);
    else console.error("API failure:", response?.data?.message);
    return;
  }
  successCallback(response);
};

/**
 *
 * @param endPoint api end point
 * @param params request data
 * @param successCallback function for handle success response
 * @param errorCallback  function for handle error response
 */
const postApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback,
) => {
  request
    .post(endPoint, params)
    .then((response) => {
      dispatchResponse(response, successCallback, errorCallback);
    })
    .catch((error) => {
      if (!navigator.onLine) {
        alert("No internet connection");
        return;
      }
      if (error.code === "ECONNABORTED") {
        let payload = {
          data: {
            statusCode: 408,
          },
        };
        errorCallback(payload);
      } else if (error.response) {
        errorCallback(error.response);
      } else if (!error.response) {
        let payload = {
          data: {
            statusCode: "",
            message: "Please try again later",
          },
        };
        errorCallback(payload);
      }
    });
};

/**
 *
 * @param endPoint api end point
 * @param params api url parameter
 * @param successCallback function for handle success response
 * @param errorCallback function for handle error response
 */
const getApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback,
) => {
  request
    .get(endPoint + params, {})
    .then((response) => {
      dispatchResponse(response, successCallback, errorCallback);
    })
    .catch((error) => {
      if (!navigator.onLine) {
        alert("No internet connection");
        return;
      }
      if (error.code === "ECONNABORTED") {
        let payload = {
          data: {
            statusCode: 408,
          },
        };
        errorCallback(payload);
      } else if (error.response) {
        errorCallback(error.response);
      } else if (!error.response) {
        let payload = {
          data: {
            statusCode: "",
            message: "Please try again later",
          },
        };
        errorCallback(payload);
      }
    });
};

/**
 *
 * @param endPoint api end point
 * @param params api request data
 * @param successCallback function for handle success response
 * @param errorCallback function for handle error response
 */
const deleteApiCall = (
  endPoint,
  params = "",
  successCallback,
  errorCallback,
) => {
  request
    .delete(endPoint + params, {})
    .then((response) => {
      dispatchResponse(response, successCallback, errorCallback);
    })
    .catch((error) => {
      if (!navigator.onLine) {
        alert("No internet connection");
        return;
      }
      if (error.code === "ECONNABORTED") {
        let payload = {
          data: {
            statusCode: 408,
          },
        };
        errorCallback(payload);
      } else if (error.response) {
        errorCallback(error.response);
      } else if (!error.response) {
        let payload = {
          data: {
            statusCode: "",
            message: "Please try again later",
          },
        };
        errorCallback(payload);
      }
    });
};

/**
 *
 * @param endPoint api end point
 * @param params api request data
 * @param successCallback function for handle success response
 * @param errorCallback function for handle error response
 */

const patchApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback,
) => {
  request
    .patch(endPoint, params)
    .then((response) => {
      dispatchResponse(response, successCallback, errorCallback);
    })
    .catch((error) => {
      if (!navigator.onLine) {
        alert("No internet connection");
        return;
      }
      if (error.code === "ECONNABORTED") {
        let payload = {
          data: {
            statusCode: 408,
          },
        };
        errorCallback(payload);
      } else if (error.response) {
        errorCallback(error.response);
      } else if (!error.response) {
        let payload = {
          data: {
            statusCode: "",
            message: "Please try again later",
          },
        };
        errorCallback(payload);
      }
    });
};
/**
 *
 * @param endPoint api end point
 * @param params request data
 * @param successCallback function for handle success response
 * @param errorCallback  function for handle error response
 */
const putApiCall = (
  endPoint,
  params,
  successCallback,
  errorCallback,
) => {
  request
    .put(endPoint, params)
    .then((response) => {
      dispatchResponse(response, successCallback, errorCallback);
    })
    .catch((error) => {
      if (!navigator.onLine) {
        alert("No internet connection");
        return;
      }
      if (error.code === "ECONNABORTED") {
        let payload = {
          data: {
            statusCode: 408,
          },
        };
        errorCallback(payload);
      } else if (error.response) {
        errorCallback(error.response);
      } else if (!error.response) {
        let payload = {
          data: {
            statusCode: "",
            message: "Please try again later",
          },
        };
        errorCallback(payload);
      }
    });
};

/**
 * export all function
 */
export const api = {
  putApiCall,
  getApiCall,
  postApiCall,
  patchApiCall,
  deleteApiCall,

};
